import styled from 'styled-components';
import { boxShadow } from 'js/config/style';
import { animated } from 'react-spring';

export default animated(styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  box-shadow: ${boxShadow};
  padding: 0.5rem 0;
  margin-top: 0.5rem;
  z-index: 1;
`);
